export default __webpack_public_path__ + "static/media/blob.cff79185.svg";